import { render } from "./UiAvatarCircular.vue?vue&type=template&id=3c37ba11"
import script from "./UiAvatarCircular.vue?vue&type=script&lang=js"
export * from "./UiAvatarCircular.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__